import React from "react";
import { FiSettings } from "react-icons/fi";
import { AiOutlinePlus } from "react-icons/ai";
import { BiChevronRight } from "react-icons/bi";
import { BiChevronLeft } from "react-icons/bi";
import StateTable from "../stateTable/StateTable";
import { Link } from "react-router-dom";
import { Pagination } from "antd";

function ListState({ data, getStateData, onChangeVal, initialVlue, handleChange, reset }) {
  return (
    <>
      <div className="pageTableWrapper">
        <div className="pageHeader">
          <div className="pageTitle">
            <FiSettings />
            <h5>STATES</h5>
          </div>

          <div className="addNew">
            <Link to="/admin/create-state" className="btn btn-success">
              <AiOutlinePlus /> Add New State
            </Link>
          </div>
        </div>

        <div className="pageBody">
          <StateTable data={data} getStateData={getStateData} initialVlue={initialVlue} handleChange={handleChange} reset={reset} />
        </div>

        <div className="pageFooter">
          <div className="row">
            <div className="col-md-6">
              <div className="showEntry">
                <p>Showing {data?.totalStates} entries</p>
              </div>
            </div>
            <div className="col-md-6">
              <Pagination
                defaultCurrent={1}
                onChange={onChangeVal}
                total={data?.totalStates}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default ListState;
